import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
    desktopRowSize: 3,
    isChooseLotteryModeTriggered: false,
    isPermsModeChosen: false,
    pickerIndex: null as number | null,
    banker: null as number | null,
    permutations: [] as Array<number> | null,
    isPermsPickerEnabled: false,
};

export const lotteryStoreSlice = createSlice({
    name: 'lotteryPlayStore',
    initialState,
    reducers: {
        setDesktopRowSize: (state, action: PayloadAction<number>) => {
            state.desktopRowSize = action.payload;
        },
        triggerChooseLotteryMode: (state, action: PayloadAction<boolean>) => {
            state.isChooseLotteryModeTriggered = action.payload;
        },
        setPermsModeChosen: (state, action: PayloadAction<boolean>) => {
            state.isPermsModeChosen = action.payload;
        },
        setCurrentPickerIndex: (state, action: PayloadAction<number>) => {
            state.pickerIndex = action.payload;
        },
        setBanker: (state, action: PayloadAction<number>) => {
            state.banker = action.payload;
        },
        setPermutations: (state, action: PayloadAction<number[]>) => {
            state.permutations = action.payload;
        },
        setIsPermsPickerEnabled: (state, action: PayloadAction<boolean>) => {
            state.isPermsPickerEnabled = action.payload;
        },
    },
});

export const {
    setDesktopRowSize,
    triggerChooseLotteryMode,
    setPermsModeChosen,
    setCurrentPickerIndex,
    setBanker,
    setPermutations,
    setIsPermsPickerEnabled,
} = lotteryStoreSlice.actions;
